/* ============
 * Users Actions
 * ============
 *
 * The actions available for the Users module.
 */

import Vue from 'vue';
import store from '@/store';
import UserApi from '@/api/user';
import * as types from './types';

export default {
  async findAll({ commit }) {
    store.dispatch('application/startLoading');
    try {
      let response = await UserApi.findAll();
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.users.findAll.error'));
      }
      const pagination = {
        current: 1,
        total: Math.ceil(response.data.nbAccounts / 20),
      };
      commit(types.SET_PAGINATION, pagination);
      return response.data;
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async findById({ commit }, userId) {
    store.dispatch('application/startLoading');
    try {
      return await UserApi.findById(userId);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async search({ commit }, searchParams) {
    store.dispatch('application/startLoading');
    try {
      let response = await UserApi.search(searchParams);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.users.search.error'));
      }
      const pagination = {
        current: (searchParams.offset + searchParams.limit) / searchParams.limit,
        total: Math.ceil((response.data.nbAccounts / searchParams.limit)),
      };
      commit(types.SET_PAGINATION, pagination);
      return response.data;
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async updateInternalUserCredentials({ commit }, params) {
    console.log(params);
    store.dispatch('application/startLoading');
    try {
      return await UserApi.updateInternalUserCredentials(params).then((response) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.users.updateInternalUserCredentials.success'),
          time: 3,
          type: 'success',
        });
        return response;
      });
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async searchSocialSigners({ commit }, searchParams) {
    store.dispatch('application/startLoading');
    try {
      let response = await UserApi.searchSocialSigners(searchParams);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.users.search.error'));
      }
      const pagination = {
        current: (searchParams.offset + searchParams.limit) / searchParams.limit,
        total: Math.ceil((response.data.nbAccounts / searchParams.limit)),
      };
      commit(types.SET_PAGINATION, pagination);
      return response.data;
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async create({ commit }, user) {
    store.dispatch('application/startLoading');
    try {
      return await UserApi.create(user).then((response) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.users.create.success'),
          time: 3,
          type: 'success',
        });
        return response;
      });
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async update({ commit }, user) {
    store.dispatch('application/startLoading');
    try {
      let response = await UserApi.update(user);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.users.update.error'));
      } else {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.users.update.success'),
          time: 3,
          type: 'success',
        });
      }
      return response.data;
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async destroy({ commit }, userId) {
    store.dispatch('application/startLoading');
    try {
      let response = await UserApi.destroy(userId);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.users.destroy.error'));
      } else {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.users.destroy.success'),
          time: 3,
          type: 'success',
        });
      }
      return response.data;
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/settings-users/actions.js